import { render, staticRenderFns } from "./ConsultHubsPage.vue?vue&type=template&id=b9547b34"
import script from "./ConsultHubsPage.vue?vue&type=script&lang=ts"
export * from "./ConsultHubsPage.vue?vue&type=script&lang=ts"
import style0 from "./ConsultHubsPage.vue?vue&type=style&index=0&id=b9547b34&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports